import styled, { css } from 'styled-components';
import { Table } from 'antd';

export const CustomTable: typeof Table = styled(Table)`
	overflow: hidden;
	border-radius: 0.5rem;
	.ant-table-thead {
		tr {
			border-bottom: 2px solid ${({ theme }) => theme.palette.secondary['50']};
			th {
				&.ant-table-selection-column {
					padding-left: 1rem;
				}
			}
		}
		.ant-table-cell {
			font-weight: 600;
			padding: 0.8rem 0.4rem;
			background-color: ${({ theme }) => theme.colors.primary};
			color: ${({ theme }) => theme.palette.secondary.white};
			&:not(:last-child):not(:first-child) {
				border-right: 2px solid ${({ theme }) => theme.palette.secondary.white};
			}
			&::before {
				display: none;
			}
		}
	}
	.ant-table-tbody {
		.ant-table-cell {
			background-color: ${({ theme }) => theme.palette.secondary.white};
		}
		td {
			padding: 1rem;
			border-bottom: 2px solid ${({ theme }) => theme.palette.secondary['50']};
		}

		.ant-table-row-selected {
			td {
				background-color: ${({ theme }) => theme.palette.primary['100']};
				border-top: 2px solid ${({ theme }) => theme.colors.primary};
				border-bottom: 2px solid ${({ theme }) => theme.colors.primary};
				border-left: none;
				border-right: none;

				&:first-child {
					border-left: 2px solid ${({ theme }) => theme.colors.primary};
					border-top-left-radius: 8px;
					border-bottom-left-radius: 8px;
					padding-left: 1rem;
					z-index: 1;
				}

				&:last-child {
					border-right: 2px solid ${({ theme }) => theme.colors.primary};
					border-top-right-radius: 8px;
					border-bottom-right-radius: 8px;
				}
			}

			& + .ant-table-row-selected td {
				border-top: none;
			}
		}
	}
`;

export const CounterText = styled.span`
	${({ theme }) => css`
		${{ ...theme.fonts.body.sm }}
	`}
`;
